import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-track-order',
  templateUrl: './track-order.component.html',
  styleUrls: ['./track-order.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class TrackOrderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
